/**
 * Types for Strapi rich text content, which is output by the
 * "Rich text (Blocks)" field type.
 */

import {StrapiImageData} from "../StrapiImage";

/**
 * @deprecated use `TextBlockType` instead for typing that is used by strapi auto-gen types
 * @link https://github.com/aops-ba/academy2/blob/staging/nextjs/shared/strapiTypes/common/Blocks.ts
 */
export enum TextNodeType {
	TEXT = "text",
	HEADING = "heading",
	LIST = "list",
	LIST_ITEM = "list-item",
	PARAGRAPH = "paragraph",
	LINK = "link",
	QUOTE = "quote",
	CODE = "code",
	IMAGE = "image",
}

/**
 * @deprecated use `TextBlock` instead for typing that is used by strapi auto-gen types
 * @link https://github.com/aops-ba/academy2/blob/staging/nextjs/shared/strapiTypes/common/Blocks.ts
 */
export interface TextNode {
	type: TextNodeType.TEXT;
	text: string;
	italic?: boolean;
	bold?: boolean;
	underline?: boolean;
	strikethrough?: boolean;
	code?: boolean;
}

/**
 * @deprecated use `AbstractParentBlock` instead for typing that is used by strapi auto-gen types
 * @link https://github.com/aops-ba/academy2/blob/staging/nextjs/shared/strapiTypes/common/Blocks.ts
 */
export interface AbstractParentNode {
	type: string;
	children: TextContentNode[];
}

/**
 * @deprecated use `HeadingBlock` instead for typing that is used by strapi auto-gen types
 * @link https://github.com/aops-ba/academy2/blob/staging/nextjs/shared/strapiTypes/common/Blocks.ts
 */
export interface HeadingNode extends AbstractParentNode {
	type: TextNodeType.HEADING;
	level: 1 | 2 | 3 | 4 | 5 | 6;
}

/**
 * @deprecated use `ListBlock` instead for typing that is used by strapi auto-gen types
 * @link https://github.com/aops-ba/academy2/blob/staging/nextjs/shared/strapiTypes/common/Blocks.ts
 */
export interface ListNode extends AbstractParentNode {
	type: TextNodeType.LIST;
	format: "unordered" | "ordered";
}

/**
 * @deprecated use `ListItemBlock` instead for typing that is used by strapi auto-gen types
 * @link https://github.com/aops-ba/academy2/blob/staging/nextjs/shared/strapiTypes/common/Blocks.ts
 */
export interface ListItemNode extends AbstractParentNode {
	type: TextNodeType.LIST_ITEM;
}

/**
 * @deprecated use `ParagraphBlock` instead for typing that is used by strapi auto-gen types
 * @link https://github.com/aops-ba/academy2/blob/staging/nextjs/shared/strapiTypes/common/Blocks.ts
 */
export interface ParagraphNode extends AbstractParentNode {
	type: TextNodeType.PARAGRAPH;
}

/**
 * @deprecated use `LinkBlock` instead for typing that is used by strapi auto-gen types
 * @link https://github.com/aops-ba/academy2/blob/staging/nextjs/shared/strapiTypes/common/Blocks.ts
 */
export interface LinkNode extends AbstractParentNode {
	type: TextNodeType.LINK;
	url: string;
}

/**
 * @deprecated use `QuoteBlock` instead for typing that is used by strapi auto-gen types
 * @link https://github.com/aops-ba/academy2/blob/staging/nextjs/shared/strapiTypes/common/Blocks.ts
 */
export interface QuoteNode extends AbstractParentNode {
	type: TextNodeType.QUOTE;
}

/**
 * @deprecated use `CodeBlock` instead for typing that is used by strapi auto-gen types
 * @link https://github.com/aops-ba/academy2/blob/staging/nextjs/shared/strapiTypes/common/Blocks.ts
 */
export interface CodeNode extends AbstractParentNode {
	type: TextNodeType.CODE;
}

export interface ImageNode extends AbstractParentNode {
	type: TextNodeType.IMAGE;
	image: StrapiImageData["attributes"];
}

/**
 * Types for Strapi rich text content, which is output by the
 * "Rich text (Blocks)" field type.
 * @deprecated use `Block` instead for typing that is used by strapi auto-gen types
 * @link https://github.com/aops-ba/academy2/blob/staging/nextjs/shared/strapiTypes/common/Blocks.ts
 */
export type TextContentNode =
	| TextNode
	| HeadingNode
	| ListNode
	| ListItemNode
	| ParagraphNode
	| LinkNode
	| QuoteNode
	| CodeNode
	| ImageNode;
